import { MenuItem } from '@mui/joy';
import { useTranslation } from 'react-i18next';

import { useAuthUser } from 'auth/hooks';
import { VendorQuoteHelper } from 'quotes/helpers';
import { IVendorQuote } from 'quotes/types';

interface IProps {
  quote: IVendorQuote;
  onOpen: () => void;
}

export const ExportSkuPartMenuItem = ({ quote, onOpen }: IProps) => {
  const { t } = useTranslation();

  const { user } = useAuthUser();

  if (!VendorQuoteHelper.isSkuExportAvailable({ quote, user })) {
    return null;
  }

  return <MenuItem onClick={onOpen}>{t('buttonLabelExportSkuParts')}</MenuItem>;
};
